import { findCandidatesLabel, isNullOrUndefinedOrEmpty } from '@/helpers/common';
import { ACCEPTANCE_CANDIDATES } from '../define/consts/solution';
import { isDoneResponse } from './professional_my_page';
/**
 * 金額をN万円単位で表示する
 * @param price
 * @deprecated 以降は src/utils/resources/rfp/rfpResource.ts を利用してください
 * @returns {number}
 */
export const viewPrice = (price) => price / 10000;
/**
 * 表示金額+万円のprefix
 * @param price
 * @returns {string}
 */
export const textPrice = (price) => `${viewPrice(price)} 万円`;
/**
 * KEY POINTSを配列にして返す
 * @param point
 * @returns {Array}
 */
export const points = (point) => point.split('\n').filter((v) => !isNullOrUndefinedOrEmpty(v));
/**
 * タグ表示の要素を配列で返す
 * @param s
 * @returns {[string, string, *|string]}
 */
export const labels = (s) => {
    const { acceptance, period, price } = s;
    return [
        isNullOrUndefinedOrEmpty(price) ? '' : `${viewPrice(price)}万円程度`,
        isNullOrUndefinedOrEmpty(period) ? '' : `約${period}週間`,
        findCandidatesLabel(ACCEPTANCE_CANDIDATES, acceptance),
    ].filter((v) => !isNullOrUndefinedOrEmpty(v));
};
/**
 * プロジェクト事例の編集が可能か
 * @param s
 * @param profile
 * @returns {boolean}
 */
export const isEnableSolutionEdit = (s, profile) => {
    const { id } = profile;
    const representative = s.representative || {};
    return s.createdBy === id || representative.id === id;
};
/**
 * 開始可能時期などの変更が可能か
 * @param s
 * @param profile
 * @returns {boolean}
 */
export const isEnableAcceptanceChange = (s, profile) => {
    const { id } = profile;
    const representative = s.representative || {};
    return representative.id === id;
};
/**
 * 送付先・責任者の変更が可能か
 * @param s
 * @param profile
 * @returns {boolean}
 */
export const isEnableSolutionChange = (s, profile) => {
    const { id } = profile;
    const representative = s.representative || {};
    return s.status !== 2 && representative.id === id;
};
/**
 * 削除が可能か
 * @param s
 * @param profile
 * @returns {boolean}
 */
export const isEnableSolutionDelete = (s, profile) => {
    const { id } = profile;
    const representative = s.representative || {};
    return s.status === 1 && representative.id === id;
};
/**
 * 担当者の変更が可能か
 * @param s
 * @param profile
 * @returns {boolean}
 */
export const isEnableStaffChange = (s, profile) => {
    const { id } = profile;
    const representative = s.representative || {};
    return representative.id === id;
};
/**
 * 注文情報の変更が可能か
 * @param s
 * @param o
 * @param profile
 * @returns {boolean}
 */
export const isEnableOrderChange = (s, o, profile) => {
    const { id } = profile;
    const representative = s.representative || {};
    const staff = o.staff || {};
    return representative.id === id || id === staff.id;
};
/**
 * 注文情報のステータスの更新が可能か
 * @param s
 * @param o
 * @param profile
 * @returns {boolean}
 */
export const isEnableOrderUpdate = (s, o, profile) => isDoneResponse(o) && isEnableOrderChange(s, o, profile);
/**
 * 完了した注文へのレビュー登録が可能か
 * @param s
 * @param o
 * @param profile
 * @returns {boolean}
 */
export const isEnableOrderReview = (s, o, profile) => !o.review && isEnableOrderChange(s, o, profile);
/**
 * 企業ユーザがレビュー済みかどうか
 * @param item
 * @returns {boolean}
 */
export const isReviewedClient = (item) => !!(item.review && item.review.valuation);
